<nav class="navbar navbar-expand bg-body text-body h-header py-0">
  <div class="container-fluid ps-0 top-nav-container">
    <div class="row mx-0 align-items-center w-100">
      <div
        [class]="
          'col px-0 d-flex align-items-center flex-nowrap min-w-0 ' +
          'justify-content-start'
        "
      >
        @if (logoTemplate()) {
          <ng-container *ngTemplateOutlet="logoTemplate()!" />
        }

        @if (startActionsTemplate()) {
          <div
            [class]="
              'navbar-nav align-items-center gap-2 start-actions-wrapper ' +
              'justify-content-start text-start'
            "
          >
            <ng-container *ngTemplateOutlet="startActionsTemplate()!" />
          </div>
        }
      </div>

      @if (endActionsTemplate()) {
        <div
          [class]="
            'col-auto px-0 d-flex align-items-center flex-nowrap ' +
            'justify-content-end'
          "
        >
          <div
            [class]="
              'navbar-nav align-items-center ' + 'justify-content-end text-end'
            "
          >
            <ng-container *ngTemplateOutlet="endActionsTemplate()!" />
          </div>
        </div>
      }
    </div>
  </div>
</nav>
